export default __webpack_public_path__ + "static/media/payment.d3e26004.png";